import React from 'react';

export default function Status(props) {
    const { title, color } = props;
    return (
        <div>
            <span className={`circle ${color}-circle`} />
            {title}
        </div>
    );
} 


// WEBPACK FOOTER //
// ./src/components/Status.jsx